import React from 'react';
import Icon from '../../../components/AppIcon';

const RegulatoryTimeline = ({ updates }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'bg-success text-success-foreground';
      case 'pending': return 'bg-warning text-warning-foreground';
      case 'upcoming': return 'bg-cta text-cta-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'CheckCircle';
      case 'pending': return 'Clock';
      case 'upcoming': return 'Calendar';
      default: return 'Info';
    }
  };

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-headline font-semibold text-xl text-text-primary">Regulatory Timeline</h3>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="Clock" size={16} />
          <span>Last updated: 2 hours ago</span>
        </div>
      </div>

      <div className="space-y-4">
        {updates.map((update, index) => (
          <div key={index} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted/50 transition-colors duration-300">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${getStatusColor(update.status)}`}>
              <Icon name={getStatusIcon(update.status)} size={20} />
            </div>
            
            <div className="flex-1">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-medium text-text-primary">{update.title}</h4>
                <span className="text-sm text-text-secondary">{update.date}</span>
              </div>
              <p className="text-sm text-text-secondary mb-2">{update.description}</p>
              <div className="flex items-center space-x-4">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(update.status)}`}>
                  {update.status.charAt(0).toUpperCase() + update.status.slice(1)}
                </span>
                <span className="text-xs text-text-secondary">Impact: {update.impact}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegulatoryTimeline;